import { useDegreeDescriptionPageElementRefs } from 'bundles/degree-description/contexts/DegreeDescriptionPageElementRefsContext';
import { useDegreeDescriptionEventingContext } from 'bundles/degree-description/providers/DegreeDescriptionEventingProvider';
import { INTERACTION_EVENTS_MAP } from 'bundles/expression-of-interest/constants';
import { useEoiEventing } from 'bundles/expression-of-interest/utils/eventingUtils';

export const EOI_ACTIONS = {
  apply: 'apply',
  requestInfo: 'requestInfo',
} as const;

type EoiAction = (typeof EOI_ACTIONS)[keyof typeof EOI_ACTIONS];

const scrollToEoiForm = (formElement?: HTMLElement | null) => {
  formElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

/**
 * Used by the experimental EOI placements (header, mobile footer, inline module,
 * at-a-glance block) that no longer render their own form -- clicking Apply/Request info scrolls
 * to the EOI box embedded in the hero (see ExperimentalEoiForm) instead of opening a
 * Coursera EOI modal.
 */
export const useScrollToEoiForm = (trackingIndex?: number) => {
  const { eoiFormAnchorRef } = useDegreeDescriptionPageElementRefs();
  const { trackingProductId } = useDegreeDescriptionEventingContext();
  const { trackInteractEoi } = useEoiEventing(trackingProductId);

  return (action: EoiAction) => {
    trackInteractEoi({
      eoiInteraction: INTERACTION_EVENTS_MAP[action].v3EventKey,
      trackingIndex,
      eoiButtonSource: action === 'apply' ? 'application_button' : 'request_info_button',
    });
    scrollToEoiForm(eoiFormAnchorRef);
  };
};
